// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"275eb2fc","239":"1d22eb09","453":"e14b2355","455":"2ad553b8"}[chunkId] + ".chunk.js";
};